var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopheader1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58153 6.32882C4.23056 3.52104 6.41988 1.04102 9.24951 1.04102H10.6686C13.5012 1.04102 15.6929 3.52366 15.3415 6.33441L15.2877 6.76519C15.1835 7.59862 14.9736 10.0665 15.5891 10.638C16.5092 11.2241 17.7729 11.7693 16.7587 13.8638C16.1149 14.8754 15.0355 15.5189 13.8516 15.6125L13.6922 15.8857C12.8482 17.3325 11.5332 18.1243 10.1524 18.1243C8.77149 18.1243 7.45649 17.3325 6.61249 15.8857L6.45559 15.6167C5.04617 15.529 3.78362 14.6895 3.16183 13.4077L3.07571 13.2301C2.9273 11.6343 3.03288 11.8053 4.22094 10.7089C4.79429 10.1799 4.74443 7.63199 4.64766 6.85786L4.58153 6.32882ZM7.93297 15.6243C8.56575 16.4891 9.38474 16.8743 10.1524 16.8743C10.92 16.8743 11.739 16.4891 12.3717 15.6243H7.93297Z",
    fill: "#F85663"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopheader1);
export default __webpack_public_path__ + "static/media/Topheader-1.7a5de9f5.svg";
export { ForwardRef as ReactComponent };